<template>
  <pattern
    :id="`${id}-bar-chart__pattern-descending`"
    x="0"
    y="0"
    :width="barWidth"
    height="40"
    patternUnits="userSpaceOnUse"
  >
    <rect x="0" y="0" width="100%" height="20" fill="rgb(229, 177, 179)" />
    <rect x="0" y="20" width="100%" height="20" fill="rgb(251, 205, 205)" />
    <path
      :d="`M0,0 L${barWidth / 2},8 L${barWidth},0 L${barWidth},-5 L0,-5 Z`"
      fill="rgb(251, 205, 205)"
    />
    <path
      :d="`M0,20 L${barWidth / 2},28 L${barWidth},20 L${barWidth},10 L0,10 Z`"
      fill="rgb(229, 177, 179)"
    />
  </pattern>
  <pattern
    :id="`${id}-bar-chart__pattern-ascending`"
    x="0"
    y="0"
    :width="barWidth"
    height="40"
    patternUnits="userSpaceOnUse"
  >
    <rect x="0" y="0" width="100%" height="10" fill="rgb(187, 227, 201)" />
    <rect x="0" y="10" width="100%" height="20" fill="rgb(194, 244, 217)" />
    <rect x="0" y="30" width="100%" height="10" fill="rgb(187, 227, 201)" />
    <path
      :d="`M0,30 L${barWidth / 2},22 L${barWidth},30 L${barWidth},40 L0,40 Z`"
      fill="rgb(187, 227, 201)"
    />
    <path
      :d="`M0,10 L${barWidth / 2},2 L${barWidth},10 L${barWidth},15 L0,15 Z`"
      fill="rgb(194, 244, 217)"
    />
  </pattern>
  <pattern
    :id="`${id}-bar-chart__pattern-descending--transparent`"
    x="0"
    y="0"
    :width="barWidth"
    height="40"
    patternUnits="userSpaceOnUse"
  >
    <path
      :d="`M0,0 L${barWidth / 2},8 L${barWidth},0 Z`"
      fill="var(--color-background-deep)"
      opacity="0.9"
    />
    <path
      :d="`M0,40 L${barWidth},40 L${barWidth},20 L${barWidth / 2},28 L0,20 Z`"
      fill="var(--color-background-deep)"
      opacity="0.9"
    />
    <path
      :d="`M0,0, L0,20 L${barWidth / 2},28 L${barWidth},20 L${barWidth},0 L${
        barWidth / 2
      },8 Z`"
      fill="var(--color-background-deep)"
      opacity="0.7"
    />
  </pattern>
  <pattern
    :id="`${id}-bar-chart__pattern-ascending--transparent`"
    x="0"
    y="0"
    :width="barWidth"
    height="40"
    patternUnits="userSpaceOnUse"
  >
    <path
      :d="`M0,0 L0,10 L${barWidth / 2},2 L${barWidth},10 L${barWidth},0 Z`"
      fill="var(--color-background-deep)"
      opacity="0.3"
    />
    <path
      :d="`M0,40 L0,30 L${barWidth / 2},22 L${barWidth},30 L${barWidth},40 Z`"
      fill="var(--color-background-deep)"
      opacity="0.3"
    />
    <path
      :d="`M0,30 0,10 L${barWidth / 2},2 L${barWidth},10 L${barWidth},30 L${
        barWidth / 2
      } 22 Z`"
      fill="var(--color-background-deep)"
      opacity="0.6"
    />
  </pattern>
  <pattern
    :id="`${id}-diagram__bar__descending__h`"
    x="0"
    y="0"
    :height="barWidth"
    width="40"
    patternUnits="userSpaceOnUse"
  >
    <rect x="0" y="0" width="20" height="15" fill="rgb(229, 177, 179)" />
    <rect x="20" y="0" width="20" height="15" fill="rgb(251, 205, 205)" />
    <path d="M20,0 L20,15 L12,8 L20,0" fill="rgb(251, 205, 205)" />
    <path d="M40,0 L40,15 L32,8 L40,0" fill="rgb(229, 177, 179)" />
  </pattern>
  <pattern
    :id="`${id}-diagram__bar__ascending__h`"
    x="0"
    y="0"
    width="40"
    :height="barWidth"
    patternUnits="userSpaceOnUse"
  >
    <rect x="0" y="0" width="20" height="15" fill="rgb(194, 244, 217)" />
    <rect x="20" y="0" width="20" height="15" fill="rgb(187, 227, 201)" />
    <path d="M0,0 L0,15 L8,8 L0,0" fill="rgb(187, 227, 201)" />
    <path d="M20,0 L28,8 L20,20 L20,0" fill="rgb(194, 244, 217)" />
  </pattern>
</template>

<script setup lang="ts">
defineProps<{
  id: string;
  barWidth: number;
}>();
</script>
